import { render, staticRenderFns } from "./LsptrazaGrid.vue?vue&type=template&id=51c425ba"
import script from "./LsptrazaGrid.vue?vue&type=script&lang=js"
export * from "./LsptrazaGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports